import { infoDialogBox } from '../../../../javascript/shared/helpers';

export default class extends Controller {
  static targets = ['subscriptionLink', 'infoBox'];

  displayInfoBox(event) {
    event && event.preventDefault()
    const content = `Turn notifications ${ (this.subscriptionState === 'subscribed') ? 'off' : 'on' }`
    this.infoBoxTarget.innerHTML = infoDialogBox(content)
  }

  hideInfoBox(event) {
    event && event.preventDefault()
    this.infoBoxTarget.innerHTML = ''
  }

  updateSubscription(event) {
    event.preventDefault()
    const link = this.subscriptionLinkTarget;
    App.Helpers.ajaxRequest({
      url: link.href,
      method: 'put',
      data: { type: this.toggleSubscriptionState() },
      successHandler: (res => {
        this.updateSubscriptionState(res)
        this.updateLinkTextAndClass()
        this.hideInfoBox()
      }).bind(this)
    });
  }

  //
  // INTERNAL USE
  //

  toggleSubscriptionState() {
    return (this.subscriptionState === 'subscribed') ? 'unsubscribed' : 'subscribed'
  }

  updateSubscriptionState(newState) {
    this.subscriptionState = newState
  }

  updateLinkTextAndClass() {
    this.subscriptionLinkTargets.forEach(button => {
      button.textContent = this.subscribeLinkText
      button.className = this.subscribeLinkClass
    })
  }

  //
  // GETTERS AND SETTERS
  //

  get subscriptionState() {
    return App.Helpers.isTruthy(this.data.get('state'))
  }

  set subscriptionState(value) {
    this.data.set('state', value);
  }

  get subscribeLinkText() {
    return (this.subscriptionState === 'subscribed') ? 'Leave discussion' : 'Join discussion'
  }

  get subscribeLinkClass() {
    return `subscribe-link ${this.subscriptionState}`
  }
};



// WEBPACK FOOTER //
// ./app/components/messages/assets/javascript/message-subscription-link-controller.js